import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    ModalBody,
    Image,
    Box,
} from "@chakra-ui/react";
import React from "react";

const ImageModal = ({ isOpen, onClose, src, alt }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
            <ModalOverlay bg="blackAlpha.800" backdropFilter="blur(10px)"/>
            <ModalContent onClick={onClose} bg="transparent" boxShadow="none" mx={{ base: "16px", md: "0" }} h="100vh" w="100vw" maxW="100vw" m={0} display="flex" justifyContent="center" alignItems="center" position="relative">
                <ModalCloseButton 
                    position="absolute"
                    top="24px" 
                    right="24px" 
                    color="white" 
                    zIndex={2} 
                    bg="blackAlpha.500" 
                    _hover={{ bg: "blackAlpha.700" }} 
                    size="lg"
                />
                <ModalBody p={0} display="flex" justifyContent="center" alignItems="center" w="100%" h="100%">
                    <Image
                        onClick={(e) => e.stopPropagation()}
                        src={src}
                        alt={alt || "Event image"}
                        objectFit="contain"
                        maxH="90vh"
                        maxW="90vw"
                        borderRadius="md"
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ImageModal;
